import type { Node } from '@atlaskit/editor-prosemirror/model';
import type { Transform } from '@atlaskit/editor-prosemirror/transform';

/**
 * Finds a node by its localId and calls the callback with the node, position, and parent.
 * @param tr - The transform to search in.
 * @param localId - The localId of the node to find.
 * @param callback - The callback to call with the node, position, and parent.
 * @returns The transform.
 */
export function findNodeByLocalId(
	tr: Transform,
	localId: string,
	callback: ({ node, pos, parent }: { node: Node; parent: Node | null; pos: number }) => void,
) {
	let found = false;
	tr.doc.descendants((node, pos, parent) => {
		if (found) {
			return false;
		}
		if (node.attrs.localId === localId) {
			found = true;
			callback({ node, pos, parent });
		}
		return !found;
	});
	if (!found) {
		throw new Error(`Node with localId ${localId} not found`);
	}
	return tr;
}
